<template>
    <div>
        <van-dialog v-model="showDialog" title="温馨提示" :show-confirm-button="false" :show-cancel-button="false"
            class="custom-dialog">
            <div class="agree_content">
                <div class="xiyibox">
                    确认删除该评论吗？
                </div>
                <div class="btn">
                    <van-button plain size="small" color="#8E8E8E" class="btn1" @click="doClose">确认</van-button>
                    <van-button plain size="small" color="#FFDB89" @click="doAgree">我再想想</van-button>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        doOpen() {
            this.showDialog = true
        },
        doClose() {
            this.showDialog = false
            this.$emit('update:value', false)
        },
        doAgree() {
            console.log(1111111)
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.doOpen()
            } else {
                this.doClose()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-dialog {
    .van-dialog__header {
        font-weight: bold;
        color: #000000;
        padding-top: 1.55rem;
        font-size: 1rem;
    }
}

.agree_content {
    width: 15.5rem;
    padding: 0 0.7rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: linear-gradient(180deg, #FFF3D4 0%, #FFFFFF 40%);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;

    .xiyibox {
        padding: 1rem 0;
    }

    .btn {
        width: 17rem;
        padding: 0 1rem;
        padding-bottom: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn1 {
            margin-right: 1.15rem !important;
        }
    }

    .img {
        position: absolute;
        display: block;
        width: 0.925rem;
        height: 0.925rem;
        bottom: -3rem;
    }
}
</style>